import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterCoinsSwap',
})
export class FilterCoinsSwapPipe implements PipeTransform {
  transform(value: string[], page: number, limit: number, isGroup: boolean): string[] {
    if (isGroup) return value.slice(page * limit, page * limit + limit);
    return value;
  }
}
